import React from 'react';

import { ToggleField } from '@dndbeyond/character-common-components/es';
import { Collapsible, CollapsibleHeaderContent, HtmlContent } from '@dndbeyond/character-components/es';
import { CharacterTheme, ConditionContract, ConditionUtils, FormatUtils } from '@dndbeyond/character-rules-engine/es';

interface Props {
    condition: ConditionContract;
    isActive: boolean;
    onConditionToggle: (condition: ConditionContract, isEnabled: boolean) => void;
    isReadonly: boolean;
    theme: CharacterTheme;
}
export default class ConditionManagePaneStandardCondition extends React.PureComponent<Props> {
    render() {
        const { isActive, condition, onConditionToggle, isReadonly, theme } = this.props;

        let classNames: Array<string> = ['ct-condition-manage-pane__condition'];
        if (isActive) {
            classNames.push('ct-condition-manage-pane__condition--active');
        }

        const name = ConditionUtils.getName(condition);

        const headingNode: React.ReactNode = (
            <div className="ct-condition-manage-pane__condition-heading">
                <div className={classNames.join(' ')}>
                    <div className="ct-condition-manage-pane__condition-preview">
                        <i
                            className={`ct-condition-manage-pane__condition-icon ${
                                theme.isDarkMode
                                    ? `i-condition-white-${FormatUtils.slugify(name)}`
                                    : `i-condition-${FormatUtils.slugify(name)}`
                            }`}
                        />
                    </div>
                    <div className="ct-condition-manage-pane__condition-name">{name}</div>
                    <div className="ct-condition-manage-pane__condition-toggle">
                        <ToggleField
                            label={`Enable ${name}`}
                            initiallyEnabled={isActive}
                            isReadonly={isReadonly}
                            onChange={onConditionToggle.bind(this, condition)}
                        />
                    </div>
                </div>
            </div>
        );
        //`
        const headerNode: React.ReactNode = <CollapsibleHeaderContent heading={headingNode} />;

        const description = ConditionUtils.getDescription(condition);

        return (
            <Collapsible layoutType={'minimal'} header={headerNode} key={ConditionUtils.getUniqueKey(condition)}>
                <div className="ct-condition-manage-pane__condition-content">
                    <HtmlContent
                        className="ct-condition-manage-pane__condition-description"
                        html={description ? description : ''}
                    />
                </div>
            </Collapsible>
        );
    }
}
